import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Footer from '../../Pages/Shared/Footer/Footer';
import Header from '../../Pages/Shared/Header/Header';
import LeftSideNav from '../../Pages/Shared/LeftSideNav/LeftSideNav';

/*course layout set for only course and course detail page, in the left side we set courses and right side course details. header and footer fixed for all pages */
const CourseLayout = () => {
    return (
        <div>
            <Header></Header>
            <Container>
                <Row className='mt-5'>
                    <Col lg="3" className='d-lg-block'>
                        <LeftSideNav></LeftSideNav>
                    </Col>
                    <Col lg="9">
                        <Outlet></Outlet>
                    </Col>
                </Row>
            </Container>
            <Footer></Footer>
        </div>
    );
};

export default CourseLayout;